module.exports = __webpack_public_path__ + "img/02.9a3e6206.jpg";